module.exports = __webpack_public_path__ + "img/365.4912398a.png";